import Player from "@vimeo/player";

if (!customElements.get("video-snippet")) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector("video, .video");
      this.player = null;
      this.isVimeo = "vimeo" in this.video.dataset;
      this._playing = false;

      if (!this.video) return;

      if (this.isVimeo) {
        this.vimeoSrc = this.src;
        this.player = new Player(this.video, {
          id: this.vimeoSrc,
        });
      }

      this.checkVideo();

      this.handleResize = () => {
        clearTimeout(this.timeout);
        setTimeout(() => {
          this.checkVideo();
        }, 200);
      };

      this.timeout = null;

      this.addEventListener("video-snippet:play", () => this._play());
      this.addEventListener("video-snippet:pause", () => this._pause());
      this.states = [];
    }

    connectedCallback() {
      window.addEventListener("resize", this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
    }

    checkFillDirection() {
      if (!this.isVimeo) return;

      Promise.all([
        this.player.getVideoWidth(),
        this.player.getVideoHeight(),
      ]).then((dimensions) => {
        const { width, height } = this.getBoundingClientRect();
        const [videoWidth, videoHeight] = dimensions;

        const containerAR = width / height;
        const videoAR = videoWidth / videoHeight;

        this.dataset.fillDirection =
          videoAR <= containerAR ? "horizontal" : "vertical";
      });
    }

    checkVideo() {
      // Only update src if it has changed, to avoid flickering on resize
      if (this.isVimeo) {
        if (this.src !== this.vimeoSrc) {
          this.vimeoSrc = this.src;
          this.player.loadVideo(this.vimeoSrc).then(() => {
            this.checkFillDirection();
          });
        } else {
          this.checkFillDirection();
        }
      } else {
        if (this.src !== this.video.src) {
          this.video.src = this.src;
        }
      }
    }

    _play() {
      if (this._playing) return;
      if (this.isVimeo) {
        if (!this.player) return;

        this._playPromise = this.player.play().then(() => {
          this._playPromise = null;
        });
      } else {
        this._playPromise = this.video.play().then(() => {
          this._playPromise = null;
        });
      }
    }

    _pause() {
      if (this._playPromise) return;

      if (this.isVimeo) {
        if (!this.player) return;

        this.player.pause();
      } else {
        this.video.pause();
      }
    }

    get src() {
      const isMobile = window.matchMedia(this.dataset.mediaQuery);
      const src = this.video.dataset.mediaSrc;
      const mobileSrc =
        "mediaSrcMobile" in this.video.dataset
          ? this.video.dataset.mediaSrcMobile
          : src;
      return isMobile.matches ? mobileSrc : src;
    }
  }

  customElements.define("video-snippet", VideoComponent);
}
